
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { AddProductForm } from "./product-dialog/AddProductForm";

interface AddProductDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (product: any) => void;
  isPoultry?: boolean;
}

export const AddProductDialog = ({
  isOpen,
  onOpenChange,
  onSubmit,
  isPoultry = false,
}: AddProductDialogProps) => {
  const handleSubmit = (product: any) => {
    onSubmit(product);
    onOpenChange(false); // Fermer le dialogue après un ajout réussi
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[700px] max-h-[95vh]">
        <DialogHeader>
          <DialogTitle>
            {isPoultry ? "Ajouter un nouveau lot" : "Ajouter un nouveau produit"}
          </DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-[calc(95vh-8rem)] px-1">
          <AddProductForm 
            onSubmit={handleSubmit}
            onCancel={() => onOpenChange(false)}
            isPoultry={isPoultry}
          />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
